import React, { useRef, useState } from 'react'
import SubHeader from '../general/SubHeader'
import emailjs from '@emailjs/browser';

const Contact = () => {
    // const form = useRef();
const [loading, setLoading] = useState(false);
 const [product, setProduct] = useState('')
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: '',
  })

  const products = ['Billing Software', 'Hotel Management Software', 'Real Estate Software', 'Face Attendance App', 'School Management Software', 'Custom Software Development Service', 'Mobile App Development', 'Website Development Service', 'Graphic Designing & Digital Marketing'] 
//     const sendEmail = (e) => {
//         e.preventDefault();
// setLoading(true);

//         emailjs
//             .sendForm('dectwin_contact', 'template_1contact', form.current, {
//                 publicKey: '47jG0NwYao8PVLzAB',
//             })
//             .then(
//                 () => {
//                     console.log('Form Submitted!');
//                     alert('Form Submission Successful');
//                     window.location.reload();
//                     setLoading(false);
//                 },
//                 (error) => {
//                     setLoading(false);
//                     console.log('FAILED...', error.text);
//                 },
//             );
//     };

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)

    // Build WhatsApp message
const text = `
Hey Dectwin! I have a requirement.

Name: ${formData.name || '-'}
Email: ${formData.email || '-'}
Mobile: ${formData.mobile || '-'}
Product: ${product || '-'}
Message: ${formData.message || '-'}
`.trim();

const encodedText = encodeURIComponent(text)    

    const waNumber = '918707510135'
    const url = `https://wa.me/${waNumber}?text=${encodedText}`

    window.open(url, '_blank')
    setLoading(false)
  }


    return (
        <>
            <SubHeader message='Contact Us' />


            <section className='my-5'>
                <div className='container'>

                    <div className='row'>

                        <div className='col-lg-4 col-md-6 col-12 my-2'>
                            <div className='contact-area'>
                                <i class="fa-solid contact-icon fa-phone"></i>
                                <div>
                                    <p className='fs-5 fw-bold my-0'>Call Us Now</p>
                                    <p className='fw-semibold text-muted'>870 751 0135</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 my-2'>
                            <div className='contact-area'>
                                <i class="fa-solid contact-icon fa-location-crosshairs"></i>
                                <div>
                                    <p className='fs-5 fw-bold my-0'>Our Office Address</p>
                                    <p className='fw-semibold text-muted'>85/47, CY Chintamani Rd, Darbhanga Colony, George Town, Prayagraj, Uttar Pradesh 211002</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 col-md-6 col-12 my-2'>
                            <div className='contact-area'>
                                <i class="fa-solid contact-icon fa-envelope"></i>
                                <div>
                                    <p className='fs-5 fw-bold my-0'>Send A Mail</p>
                                    <p className='fw-semibold text-muted'>contact@dectwinservices.com</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    {/* row ends */}

                </div>
            </section>

            {/* form section */}
            <section className='banner-bg py-5'>
                <div className='container'>

                    <p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> Get In Touch</p>
                    <p className='sec-heading my-0'>We'd Love to Hear From You</p>

                    <form className="row g-3 my-4 col-lg-8" onSubmit={handleSubmit}>
                        <div className="col-12">
                            <input type="text" className="support-input" id="inputText4" placeholder='Your Name*'  name='name'
                value={formData.name}
                onChange={handleChange} required />
                        </div>

                        <div className="col-md-6">
                            <input type="email" className="support-input" id="inputEmail4" placeholder='Your Email'  name='email'
                value={formData.email}
                onChange={handleChange} />
                        </div>

                        <div className="col-md-6">
                            <input type="tel" className="support-input" id="inputNumber4" placeholder='Mobile Number*' name='mobile' value={formData.mobile}
                onChange={handleChange}
                maxLength={10} required />
                        </div>

  <div className='col-12'>
              <select
                className='support-input text-muted'
                value={product}
                onChange={(e) => setProduct(e.target.value)}
                required
              >
                <option value='' disabled>Select Product*</option>
                {products.map((p, idx) => (
                  <option key={idx} value={p}>{p}</option>
                ))}
              </select>
            </div>

                        <div className="col-12">
                            <textarea type="text" className="support-input" id="inputAddress" placeholder="Write your Message.." name='message' value={formData.message}
                onChange={handleChange} style={{ height: '8em' }} />
                        </div>

<button type="submit" className="header-btn w-100" disabled={loading}>
  {loading ? 'Submitting...' : 'Submit Now'}
</button>
                    </form>

                </div>
            </section>
            {/* form section ends */}

            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28842.050883322736!2d82.16927067334878!3d25.362723266673317!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398555df0e636aa3%3A0x85a9c468f03b08a2!2sDECTWIN%20SERVICES!5e0!3m2!1sen!2sin!4v1739015905708!5m2!1sen!2sin"
                className='w-100' height="500" style={{ border: '0' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

        </>
    )
}

export default Contact
